import { memo } from 'react';
import NotFoundImage from 'assets/images/404';
import { Container, StyledTitle, StyledDescription } from './styles';

const NoContent = memo(({ title = 'Nothing found', description = '' }) => (
  <Container>
    <NotFoundImage />
    <StyledTitle>{title}</StyledTitle>
    <StyledDescription>{description}</StyledDescription>
  </Container>
));

export default NoContent;
